import Api from "../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },

        countryGridIsOpen: true,
        countryFormIsOpen: false,
        countryActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showCountrySearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új ország',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newCountry'
            }
        ],
        countryRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyCountry'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteCountry'
            }
        ],
        countryFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToCountryGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetCountryForm'
            }
        ],
        countrySearchFields: [
            {
                name: "name",
                label: "Név",
                formSize: 4,
                formVisible: true,
                formType: "text"
            }
        ],
        countryHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "name",
                label: "Név",
                visibility: true,
                sort: true,
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "text"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        countyGridIsOpen: true,
        countyFormIsOpen: false,
        countyActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showCountySearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új megye',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newCounty'
            }
        ],
        countyRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyCounty'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteCounty'
            }
        ],
        countyFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToCountyGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetCountyForm'
            }
        ],
        countySearchFields: [
            {
                name: "name",
                label: "Név",
                formSize: 4,
                formVisible: true,
                formType: "text"
            },
            {
                name: "region",
                label: "Régió",
                formSize: 4,
                formVisible: true,
                formType: "text"
            }
        ],
        countyHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "name",
                label: "Név",
                visibility: true,
                sort: true,
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "text"
            },
            {
                name: "region",
                label: "Régió",
                visibility: true,
                sort: true,
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "text"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        cityGridIsOpen: true,
        cityFormIsOpen: false,
        cityActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showCitySearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új város',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newCity'
            }
        ],
        cityRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyCity'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteCity'
            }
        ],
        cityFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToCityGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetCityForm'
            }
        ],
        citySearchFields: [
            {
                name: "zip",
                label: "Irányítószám",
                formSize: 3,
                formVisible: true,
                formType: "number"
            },
            {
                name: "name",
                label: "Név",
                formSize: 3,
                formVisible: true,
                formType: "text"
            },
            {
                name: "countryId",
                label: "Ország",
                formSize: 3,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCountryOptions,
                    formatText: function (val) {
                        return val.name;
                    },
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "countyId",
                label: "Megye",
                formSize: 3,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAllCountyToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            }
        ],
        cityHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "zip",
                label: "Irányítószám",
                visibility: true,
                sort: true,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "name",
                label: "Név",
                visibility: true,
                sort: true,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "country.name",
                label: "Ország",
                visibility: true,
                formVisible: false
            },
            {
                name: "county.name",
                label: "Megye",
                visibility: true,
                formVisible: false
            },
            {
                name: "countryId",
                label: "Ország",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCountryOptions,
                    formatText: function (val) {
                        return val.name;
                    },
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "countyId",
                label: "Megye",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAllCountyToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
    }
}
